import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from '../public/locales/en.json';

const supportedLngs = [
  'en',
  'es-mx',
  'fr-CA',
];

export const i18nInitPromise = i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,

    supportedLngs,
    nonExplicitSupportedLngs: true,

    backend: {
      loadPath: '/locales/{{lng}}.json',
    },

    // Bundle English translations so they're available synchronously
    // (no HTTP fetch needed for the default language).
    // Other languages are loaded via HttpBackend on demand.
    resources: {
      en: { translation: enTranslation },
    },
    partialBundledLanguages: true,

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
